import { i18n } from 'i18n';

export const CHANNEL_LANGUAGES: { [key: string]: string } = {
	ru: i18n.t('Русский'),
	en: i18n.t('Английский'),
};
